<template>
  <div id="app">
    <router-view class="child-view"></router-view>
  </div>
</template>

<script>
var skeleton_frame_url = ''
export default {
  name: 'App',
  //通过配置项的形式使用生命周期钩子
  //#region
  mounted() {
    //页面加载时显示骨架屏
    var hash = location.hash
    if (hash && hash.indexOf('pregnant_in_9_cycles/report_list?') >= 0) {
      skeleton_frame_url = 'pregnant_in_9_cycles_report_list'
    } else if (hash && hash.indexOf('analysis_report/report?') >= 0) {
      skeleton_frame_url = 'analysis_report_report'
    } else if (hash && hash.indexOf('pregnant_in_9_cycles?') >= 0) {
      skeleton_frame_url = 'pregnant_in_9_cycles'
    }
    if (skeleton_frame_url) {
      var skeleton_frame = document.getElementById(
        'skeleton_frame_' + skeleton_frame_url
      )
      if (skeleton_frame) {
        skeleton_frame.setAttribute('style', 'display:block')
      }
    }
  },
  beforeUpdate() {
    //页面加载完成隐藏骨架屏
    if (skeleton_frame_url) {
      var skeleton_frame = document.getElementById(
        'skeleton_frame_' + skeleton_frame_url
      )
      if (skeleton_frame) {
        skeleton_frame.setAttribute('style', 'display:none')
      }
    }
  },
  //#endregion
  data() {
    return {
      transitionName: 'slide-left'
    }
  },
  created() {
    let { authToken } = this.$route.query
    if (authToken) {
      this.$cookies.set('authToken', authToken)
    }

    var docEl = document.documentElement
    var width = docEl.getBoundingClientRect().width
    var rem = width / 10 //这个10，请根据自己项目进行修改，10rem等于占宽100%
    rem = parseFloat(rem.toFixed(3))
    docEl.style.fontSize = rem + 'px'
    // 修正系统字体调整造成的布局问题
    var realitySize = parseFloat(
      window.getComputedStyle(document.documentElement).fontSize
    )
    if (rem !== realitySize) {
      rem = (rem * rem) / realitySize
      docEl.style.fontSize = rem + 'px'
    }
    window.REM = rem
  }
}
</script>

<style>
#app {
  font-size: 16px;
  /* max-width: 375px; */
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.van-cell__title{
  display: flex;
  align-items: center;
}
.van-grid-item__content{
  padding: 12px 0px  !important;
  background: none !important;
  
}
</style>
